import { render, staticRenderFns } from "./Map2.vue?vue&type=template&id=4cf61f3c&"
import script from "./Map2.vue?vue&type=script&lang=js&"
export * from "./Map2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports